module.exports = __webpack_public_path__ + "static/media/coreLearning6.a4f201c3.webp";